import { Map } from 'immutable';

import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

let _callingPointsStore = new Map();


class CallingPointsStore extends BaseStore {

    get (service) {
        const key = service.journey.callingPoints;
        return _callingPointsStore.get(key);
    }

    handleLoaded({ key, callingPoints }) {
        _callingPointsStore = _callingPointsStore.set(key, callingPoints);
        this.emitChange();
    }

    handleLoadFailed({ key }) {
        this.handleLoaded({ key, callingPoints: null });
    }

    getActionHandlers () {
        return {
            [ActionTypes.CALLING_POINTS_LOADED]: this.handleLoaded,
            [ActionTypes.CALLING_POINTS_LOAD_FAILED]: this.handleLoadFailed
        };
    }

}

const storeInstance = new CallingPointsStore();


export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/CallingPointsStore.js